import { createAction, props } from '@ngrx/store';
import { ResourceUri } from '@ngxp/rest';
import type { VerfuegungResource } from '@schir-int-client/verfuegung-shared';
import {
	AdressatListResource,
	AdressatWithResource,
	Aufgabe,
	AufgabeListResource,
	AufgabeResource,
} from './aufgabe.model';
import { RegisterName } from '@schir-int-client/register-shared';

const PREFIX = '[Aufgabe] ';

export const loadAufgabenByVerfuegungAction = createAction(PREFIX + 'Load Aufgaben By Verfuegung');

export const loadAufgabenByVerfuegungSuccessAction = createAction(
	PREFIX + 'Load Aufgaben By Verfuegung Success',
	props<{
		verfuegung: VerfuegungResource;
		aufgaben: AufgabeListResource;
		register: RegisterName;
	}>()
);

export const createAufgabeAction = createAction(
	PREFIX + 'Create Aufgabe',
	props<{
		aufgabe: Aufgabe;
	}>()
);

export const createAufgabeSuccessAction = createAction(
	PREFIX + 'Create Aufgabe Success Action',
	props<{
		aufgabe: AufgabeResource;
	}>()
);

export const updateAufgabeAction = createAction(
	PREFIX + 'Update Aufgabe',
	props<{
		aufgabe: Aufgabe;
	}>()
);

export const updateAufgabeSuccessAction = createAction(
	PREFIX + 'Update Aufgabe Success',
	props<{
		aufgabe: AufgabeResource;
	}>()
);

export const loadAdressatenByAufgabeAction = createAction(
	PREFIX + 'Load Adressaten By Aufgabe',
	props<{
		aufgabe: AufgabeResource;
	}>()
);

export const loadAdressatenSuccessAction = createAction(
	PREFIX + 'Load Adressaten Success',
	props<{
		aufgabeUri: ResourceUri;
		adressaten: AdressatListResource;
	}>()
);

export const enrichAdressatenAction = createAction(
	PREFIX + 'Enrich Adressaten',
	props<{
		aufgabeUri: ResourceUri;
		adressaten: AdressatWithResource[];
	}>()
);

export const markAufgabeAsErledigtAction = createAction(
	PREFIX + 'Mark Aufgabe As Erledigt',
	props<{
		aufgabe: AufgabeResource;
	}>()
);

export const markAufgabeAsFreigegebenAction = createAction(
	PREFIX + 'Mark Aufgabe As Freigegeben',
	props<{
		aufgabe: AufgabeResource;
	}>()
);

export const loadAufgabeSuccessAction = createAction(
	PREFIX + 'Load Aufgabe Success',
	props<{
		aufgabe: AufgabeResource;
	}>()
);

export const clearAdressatenByAufgabeAction = createAction(
	PREFIX + 'Clear Adressaten By Aufgabe',
	props<{
		aufgabeUri: ResourceUri;
	}>()
);

export const deleteAufgabeAction = createAction(
	PREFIX + 'Delete Aufgabe',
	props<{
		aufgabe: AufgabeResource;
	}>()
);

export const clearSelectedAufgabeAction = createAction(PREFIX + 'Clear Selected Aufgabe');
